import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=acba1326&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acba1326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acba1326')) {
      api.createRecord('acba1326', component.options)
    } else {
      api.reload('acba1326', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=acba1326&scoped=true&", function () {
      api.rerender('acba1326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r5bOZi66Cwiw/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports